import "./style.css"

function Error() {

    return (
        <div className='page page_error'>
            error
        </div>
    )
}

export default Error;